function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 6l-5.56 4-3.25-2.2a.995.995 0 01-.02-1.64L7 3.4c.34-.24.8-.25 1.14-.02L12 6zm8.81 1.8L17.56 10 12 6l3.86-2.61c.35-.23.8-.23 1.14.02l3.83 2.76c.57.4.56 1.24-.02 1.63zM12 14l-4.44 3L5 15.16l-1.84-1.32c-.56-.41-.55-1.25.02-1.64L6.43 10 12 14zm8.81-1.8c.58.39.59 1.23.02 1.64L19 15.16 16.44 17 12 14l5.56-4 3.25 2.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 15.16v2.97c0 .39-.23.74-.58.91l-6 2.77c-.27.12-.57.12-.84 0l-6-2.77c-.35-.16-.58-.52-.58-.91v-2.97L7.56 17 12 14l4.44 3L19 15.16z"
})));